import { useContext } from 'react';
import { DataGridContext } from "../provider/DataGridProvider.js";
export function useDataGrid() {
  return useContext(DataGridContext);
}